import { Role } from "types/Role";

const ONBOARDING_MANAGEMENT_PERMISSION_GROUPS = [
  "Master",
  "Access onboarding",
] as const;

/**
 * Derived by the backend (auth/get-role.js) for the head of a department whose
 * «Vadovas priima darbuotojus» checkbox is on; never stored in a group.
 */
export const HIRING_HEAD_PERMISSION = "Access onboarding (own departments)";

/**
 * HR: every onboarding of the company, plus what stays HR-only — contract
 * registration, amendments, job leave, early activation, the History log.
 */
export function canManageOnboarding(role?: Role | null) {
  return ONBOARDING_MANAGEMENT_PERMISSION_GROUPS.some((permissionGroup) =>
    role?.permissionsgroups?.includes(permissionGroup)
  );
}

/**
 * Runs a hire end to end (create, documents, signing, medical, activation):
 * HR company-wide, or a hiring head on the records of his departments — the
 * backend limits which records a head gets.
 */
export function canLeadHiring(role?: Role | null) {
  return canManageOnboarding(role) || isHiringHead(role);
}

export function isHiringHead(role?: Role | null) {
  return !!role?.permissionsgroups?.includes(HIRING_HEAD_PERMISSION);
}

/** Strictly Master — used for Master-only onboarding actions (e.g. department assignment). */
export function isMaster(role?: Role | null) {
  return !!role?.permissionsgroups?.includes("Master");
}

/** The work-safety specialist («Tvarkos»); also sees and approves health checks company-wide. */
const WORK_SAFETY_SPECIALIST_PERMISSION = "Access work security assignments";

/**
 * My Work medical checks tab: Master, 'Access onboarding' and the work-safety
 * specialist see the whole company's queue, a hiring head the queue of his own
 * people (backend-scoped).
 */
export function canAccessMedicalQueue(role?: Role | null) {
  return (
    canManageOnboarding(role) ||
    isHiringHead(role) ||
    !!role?.permissionsgroups?.includes(WORK_SAFETY_SPECIALIST_PERMISSION)
  );
}
